export const colors = {
  borderGrey: { 100: '#4B484D' },
  textColor: {
    100: '#E0E0E0',
  },
  bgColor: {
    100: '#0F0A13',
  },
  bgColorA: {
    100: 'rgb(15, 10, 19, 0.54)',
  },
  green: {
    100: '#B4EB56',
  },
  greenA: {
    900: '#171515',
  },
};
